<template>
    <div class="member-info-page">
        <!-- 顶部提示 -->
        <div class="top-notice">
            <span class="notice-text">恭喜您注册成功，完善信息才能成为会员</span>
        </div>

        <!-- 表单内容 -->
        <div class="form-container">
            <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" size="large">
                <!-- 基本信息区域 -->
                <div class="form-section">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="真实姓名" prop="realName">
                                <el-input v-model="form.realName" placeholder="请输入真实姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="手机" prop="phone">
                                <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="电子邮箱" prop="email">
                                <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="出生日期" prop="birthday">
                                <el-date-picker v-model="form.birthday" type="date" placeholder="请选择出生日期"
                                    format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="任职单位" prop="company">
                                <el-input v-model="form.company" placeholder="请输入任职单位"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="职称" prop="title">
                                <el-input v-model="form.title" placeholder="请输入职称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="最终学历" prop="education">
                                <el-radio-group v-model="form.education">
                                    <el-radio label="大专">大专</el-radio>
                                    <el-radio label="本科">本科</el-radio>
                                    <el-radio label="硕士">硕士</el-radio>
                                    <el-radio label="博士">博士</el-radio>
                                    <el-radio label="其他">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="学位证书号" prop="degreeNo">
                                <el-input v-model="form.degreeNo" placeholder="请输入学位证书号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="毕业院校" prop="graduateSchool">
                                <el-input v-model="form.graduateSchool" placeholder="请输入毕业院校"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="专业" prop="major">
                                <el-input v-model="form.major" placeholder="请输入专业"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="从事心理咨询的起始时间" prop="startDate">
                                <el-date-picker v-model="form.startDate" type="date" placeholder="请选择起始时间"
                                    format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 见习/实习经历标题 -->
                <div class="section-title">
                    <h3>见习/实习经历</h3>
                </div>

                <!-- 经历列表 -->
                <div v-for="(exp, index) in form.experiences" :key="index" class="experience-section">
                    <div class="exp-header">
                        <span class="exp-title">第 {{ index === 0 ? '一' : index === 1 ? '二' : index + 1 }} 段经历</span>
                        <el-button v-if="index > 0" type="danger" link @click="removeExperience(index)">删除</el-button>
                    </div>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="时间" :prop="'experiences.' + index + '.time'">
                                <el-date-picker v-model="exp.time" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
                                    value-format="YYYY-MM-DD" style="width: 100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="见习/实习地点" :prop="'experiences.' + index + '.location'">
                                <el-input v-model="exp.location" placeholder="见习/实习地点"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="督导老师姓名" :prop="'experiences.' + index + '.supervisorName'">
                                <el-input v-model="exp.supervisorName" placeholder="输入老师姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="接受督导小时数" :prop="'experiences.' + index + '.supervisorHours'">
                                <el-input v-model="exp.supervisorHours" placeholder="输入小时数" type="number"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 添加经历按钮 -->
                <div class="add-exp-btn">
                    <el-button type="primary" @click="addExperience">点此可继续增加新的经历</el-button>
                </div>

                <!-- 其他信息 -->
                <div class="other-info-section">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="此前是否已是我协会的会员" prop="isMember">
                                <el-radio-group v-model="form.isMember">
                                    <el-radio label="是">是</el-radio>
                                    <el-radio label="否">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="是否有违规记录" prop="hasViolation">
                                <el-radio-group v-model="form.hasViolation">
                                    <el-radio label="是">是</el-radio>
                                    <el-radio label="否">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="服务人次" prop="serviceCount">
                                <el-input v-model="form.serviceCount" placeholder="服务人次" type="number"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="督导个案数" prop="caseCount">
                                <el-input v-model="form.caseCount" placeholder="督导个案数" type="number"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="其它补充说明" prop="remark">
                                <el-input v-model="form.remark" type="textarea" :rows="4"
                                    placeholder="请输入内容"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="个人会员同意" prop="agree">
                                <el-checkbox v-model="form.agree">同意</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 文件上传区域 -->
                <div class="upload-section">
                    <div class="section-title">
                        <h3>附件上传</h3>
                    </div>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="个人照片" prop="photoUrl">
                                <el-upload
                                    :action="upload_url"
                                    :headers="headers"
                                    :limit="1"
                                    :on-success="handlePhotoSuccess"
                                    :on-error="handleImgError"
                                    :before-upload="beforeUpload"
                                    :show-file-list="false"
                                    accept="image/jpeg,image/jpg,image/png">
                                    <div class="upload-box">
                                        <el-image v-if="form.photoUrl" class="upload-preview" :src="form.photoUrl" fit="cover" />
                                        <div v-else class="upload-placeholder">
                                            <el-icon size="28"><Plus /></el-icon>
                                            <span>上传照片</span>
                                        </div>
                                    </div>
                                </el-upload>
                                <div class="upload-tip">请上传个人证件照，支持JPG、PNG格式，5MB以内</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="资格证书" prop="certificateUrl">
                                <el-upload
                                    :action="upload_url"
                                    :headers="headers"
                                    :limit="1"
                                    :on-success="handleCertificateSuccess"
                                    :on-error="handleImgError"
                                    :before-upload="beforeUpload"
                                    :show-file-list="false"
                                    accept="image/jpeg,image/jpg,image/png">
                                    <div class="upload-box">
                                        <el-image v-if="form.certificateUrl" class="upload-preview" :src="form.certificateUrl" fit="cover" />
                                        <div v-else class="upload-placeholder">
                                            <el-icon size="28"><Plus /></el-icon>
                                            <span>上传证书</span>
                                        </div>
                                    </div>
                                </el-upload>
                                <div class="upload-tip">请上传心理咨询师资格证书，支持JPG、PNG格式</div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="学位证书" prop="degreeUrl">
                                <el-upload
                                    :action="upload_url"
                                    :headers="headers"
                                    :limit="1"
                                    :on-success="handleDegreeSuccess"
                                    :on-error="handleImgError"
                                    :before-upload="beforeUpload"
                                    :show-file-list="false"
                                    accept="image/jpeg,image/jpg,image/png">
                                    <div class="upload-box">
                                        <el-image v-if="form.degreeUrl" class="upload-preview" :src="form.degreeUrl" fit="cover" />
                                        <div v-else class="upload-placeholder">
                                            <el-icon size="28"><Plus /></el-icon>
                                            <span>上传证书</span>
                                        </div>
                                    </div>
                                </el-upload>
                                <div class="upload-tip">请上传学位证书扫描件，支持JPG、PNG格式</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 审核状态提示 -->
                <el-alert v-if="auditStatus !== null"
                    :type="auditStatus === 1 ? 'success' : auditStatus === 2 ? 'warning' : 'info'" :closable="false"
                    class="audit-status-alert">
                    <template #title>
                        <span>审核状态：{{ auditStatusText }}</span>
                        <span v-if="auditStatus === 2 && memberInfo.audit_remark" class="audit-remark">
                            （驳回原因：{{ memberInfo.audit_remark }}）
                        </span>
                    </template>
                </el-alert>

                <!-- 提交按钮 -->
                <div class="submit-btn-area">
                    <el-button type="primary" size="large" :loading="submitting"
                        @click="submitForm">
                        {{ submitting ? '提交中...' : '立即提交' }}
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '@/api/index'
import attachment from '@/api/public'
import { Plus } from '@element-plus/icons-vue'
import { MEMBER_TYPES, AUDIT_STATUS_NAMES } from '@/utils/constants'
import { mobileRule, emailRule } from '@/utils/validate'

export default {
    name: 'MemberInfo',

    components: { Plus },

    data() {
        return {
            MEMBER_TYPES,
            upload_url: '',
            form: {
                realName: '',
                phone: '',
                email: '',
                birthday: '',
                company: '',
                title: '',
                education: '本科',
                degreeNo: '',
                graduateSchool: '',
                major: '',
                startDate: '',
                experiences: [
                    {
                        time: [],
                        location: '',
                        supervisorName: '',
                        supervisorHours: ''
                    },
                    {
                        time: [],
                        location: '',
                        supervisorName: '',
                        supervisorHours: ''
                    }
                ],
                isMember: '否',
                hasViolation: '否',
                serviceCount: '',
                caseCount: '',
                remark: '',
                agree: false,
                // 文件上传
                photoUrl: '',
                certificateUrl: '',
                degreeUrl: ''
            },
            rules: {
                realName: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    mobileRule
                ],
                email: [
                    { required: true, message: '请输入电子邮箱', trigger: 'blur' },
                    emailRule
                ],
                birthday: [
                    { required: true, message: '请选择出生日期', trigger: 'change' }
                ],
                company: [
                    { required: true, message: '请输入任职单位', trigger: 'blur' }
                ],
                education: [
                    { required: true, message: '请选择最终学历', trigger: 'change' }
                ],
                agree: [
                    {
                        validator: (_rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请同意会员协议'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            submitting: false,
            loading: false
        }
    },

    computed: {
        ...mapGetters('auth', ['memberInfo', 'memberType', 'auditStatus', 'token']),

        headers() {
            return {
                'Authorization': this.token || 'no-token'
            }
        },

        isIndividual() {
            return this.memberType === MEMBER_TYPES.INDIVIDUAL
        },

        isOrganization() {
            return this.memberType === MEMBER_TYPES.ORGANIZATION
        },

        isDirector() {
            return this.memberType === MEMBER_TYPES.DIRECTOR
        },

        auditStatusText() {
            return AUDIT_STATUS_NAMES[this.auditStatus] || '未提交'
        },

        canEdit() {
            // 待审核或已驳回可以编辑
            return this.auditStatus === 0 || this.auditStatus === 2
        }
    },

    mounted() {
        attachment.uploadFileUrl().then(res => {
            this.upload_url = res
        })
        this.loadMemberInfo()
    },

    methods: {
        ...mapActions('auth', ['refreshMemberInfo']),

        // 上传前校验
        beforeUpload(file) {
            const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
            const isLt5M = file.size / 1024 / 1024 < 5

            if (!isImage) {
                this.$message.error('只能上传 JPG/PNG 格式的图片！')
                return false
            }
            if (!isLt5M) {
                this.$message.error('图片大小不能超过 5MB！')
                return false
            }
            return true
        },

        // 上传成功 - 个人照片
        handlePhotoSuccess(res) {
            if (res.code == 4000) {
                this.$message.error(res.msg)
            } else {
                this.form.photoUrl = res.data.url
                this.$message.success('上传成功！')
            }
        },

        // 上传成功 - 资格证书
        handleCertificateSuccess(res) {
            if (res.code == 4000) {
                this.$message.error(res.msg)
            } else {
                this.form.certificateUrl = res.data.url
                this.$message.success('上传成功！')
            }
        },

        // 上传成功 - 学位证书
        handleDegreeSuccess(res) {
            if (res.code == 4000) {
                this.$message.error(res.msg)
            } else {
                this.form.degreeUrl = res.data.url
                this.$message.success('上传成功！')
            }
        },

        // 上传失败
        handleImgError(err) {
            this.$message.error('上传失败，请重试！')
            console.error('上传错误：', err)
        },

        /**
         * 加载会员信息
         */
        async loadMemberInfo() {
            if (!this.memberInfo || !this.memberInfo.id) {
                return
            }

            this.loading = true

            try {
                const res = await api.info()

                if (res && res.data) {
                    const data = res.data
                    this.form = {
                        ...this.form,
                        realName: data.name || '',
                        phone: data.phone || '',
                        email: data.email || '',
                        birthday: data.birthday || '',
                        company: data.company || '',
                        title: data.title || '',
                        education: data.education || '本科',
                        degreeNo: data.degree_no || '',
                        graduateSchool: data.graduate_school || '',
                        major: data.major || '',
                        startDate: data.start_date || '',
                        experiences: data.experiences ? (typeof data.experiences === 'string' ? JSON.parse(data.experiences) : data.experiences) : this.form.experiences,
                        hasViolation: data.has_violation || '否',
                        serviceCount: data.service_count || '',
                        caseCount: data.case_count || '',
                        remark: data.remark || '',
                        photoUrl: data.photo || '',
                        certificateUrl: data.certificate || '',
                        degreeUrl: data.degree_certificate || ''
                    }
                }
            } catch (error) {
                console.error('加载会员信息失败:', error)
            } finally {
                this.loading = false
            }
        },

        // 添加经历
        addExperience() {
            this.form.experiences.push({
                time: [],
                location: '',
                supervisorName: '',
                supervisorHours: ''
            })
        },

        // 删除经历
        removeExperience(index) {
            this.form.experiences.splice(index, 1)
        },

        // 提交表单
        async submitForm() {
            const valid = await this.$refs.formRef.validate().catch(() => false)
            if (!valid) {
                this.$message.error('请完善必填信息')
                return
            }

            this.submitting = true

            try {
                // 准备提交数据 - 对应 this_mha_member 表字段
                const submitData = {
                    name: this.form.realName,
                    phone: this.form.phone,
                    email: this.form.email,
                    birthday: this.form.birthday,
                    company: this.form.company,
                    title: this.form.title,
                    education: this.form.education,
                    degree_no: this.form.degreeNo,
                    graduate_school: this.form.graduateSchool,
                    major: this.form.major,
                    start_date: this.form.startDate,
                    experiences: JSON.stringify(this.form.experiences),
                    has_violation: this.form.hasViolation,
                    service_count: this.form.serviceCount ? Number(this.form.serviceCount) : 0,
                    case_count: this.form.caseCount ? Number(this.form.caseCount) : null,
                    remark: this.form.remark,
                    photo: this.form.photoUrl,
                    certificate: this.form.certificateUrl,
                    degree_certificate: this.form.degreeUrl
                }

                const res = await api.update(submitData)

                if (res && res.code === 2000) {
                    this.$message.success(res.msg || '提交成功！')

                    // 刷新会员信息
                    if (res.data) {
                        await this.refreshMemberInfo(res.data)
                    }

                    // 跳转到首页
                    this.$router.push('/user/home')
                }
            } catch (error) {
                console.error('提交失败:', error)
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.member-info-page {
    background: #fff;
    min-height: 100%;
    padding-bottom: 40px;
}

.top-notice {
    padding: 20px 40px;
    border-bottom: 1px solid #eee;

    .notice-text {
        font-size: 16px;
        color: #333;

        &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 16px;
            background: #3eaef4;
            margin-right: 10px;
            vertical-align: middle;
        }
    }
}

.form-container {
    padding: 30px 60px;
    max-width: 1400px;
    margin: 0 auto;
}

.form-section {
    margin-bottom: 20px;
}

.section-title {
    text-align: center;
    margin: 40px 0 30px;

    h3 {
        font-size: 18px;
        color: #333;
        font-weight: 600;
        position: relative;
        display: inline-block;

        &::before,
        &::after {
            content: '';
            position: absolute;
            top: 50%;
            width: 60px;
            height: 1px;
            background: #ddd;
        }

        &::before {
            left: -80px;
        }

        &::after {
            right: -80px;
        }
    }
}

.experience-section {
    background: #fafafa;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #eee;
}

.exp-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    .exp-title {
        font-size: 15px;
        color: #3eaef4;
        font-weight: 500;
    }
}

.add-exp-btn {
    text-align: center;
    margin: 30px 0;

    :deep(.el-button) {
        width: 300px;
        height: 44px;
        background: #3eaef4;
        border-color: #3eaef4;
        border-radius: 4px;

        &:hover {
            background: #5bbef7;
            border-color: #5bbef7;
        }
    }
}

.other-info-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px dashed #ddd;
}

.submit-btn-area {
    text-align: center;
    margin-top: 40px;

    :deep(.el-button) {
        width: 200px;
        height: 48px;
        font-size: 16px;
        background: #3eaef4;
        border-color: #3eaef4;
        border-radius: 24px;

        &:hover {
            background: #5bbef7;
            border-color: #5bbef7;
        }

        &.is-disabled {
            background: #a0cfff;
            border-color: #a0cfff;
        }
    }
}

.upload-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px dashed #ddd;

    .upload-box {
        width: 178px;
        height: 178px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color 0.3s;

        &:hover {
            border-color: #3eaef4;
        }

        .upload-preview {
            width: 100%;
            height: 100%;
        }

        .upload-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #8c939d;

            span {
                margin-top: 8px;
                font-size: 13px;
            }
        }
    }

    .upload-tip {
        margin-top: 7px;
        color: #909399;
        font-size: 12px;
        line-height: 1.5;
    }
}

.audit-status-alert {
    margin: 20px 0;

    .audit-remark {
        margin-left: 10px;
        color: #e6a23c;
    }
}

// 表单样式调整
:deep(.el-form-item) {
    margin-bottom: 22px;
}

:deep(.el-form-item__label) {
    color: #666;
    font-weight: normal;
}

:deep(.el-input__wrapper) {
    border-radius: 4px;
}

:deep(.el-input) {
    height: 40px;
}

:deep(.el-select) {
    width: 100%;
}

:deep(.el-textarea__inner) {
    border-radius: 4px;
}

:deep(.el-radio) {
    margin-right: 20px;
}

:deep(.el-date-editor) {
    --el-date-editor-width: 100%;
}
</style>
